import { Search } from 'lucide-react';

interface TopbarSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onSubmit?: (value: string) => void;
  className?: string;
}

export function TopbarSearch({
  value,
  onChange,
  placeholder = 'Tìm kiếm...',
  onSubmit,
  className = '',
}: TopbarSearchProps) {
  return (
    <form
      className={`flex h-10 w-full items-center gap-2 rounded-md border border-slate-200 bg-white px-3 text-sm text-slate-500 shadow-sm ${className}`}
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit?.(value);
      }}
    >
      <Search className="h-4 w-4 text-slate-400" />
      <input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="h-full min-w-0 flex-1 border-0 bg-transparent text-sm text-slate-700 outline-none placeholder:text-slate-400"
      />
    </form>
  );
}
